'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _effects = require('redux-saga/effects');

var _disciplines = require('../actions/disciplines');

var _api = require('../api');

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fetchDisciplines),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(fetchDisciplinesRequest);

function fetchDisciplines() {
    var response, disciplines;
    return regeneratorRuntime.wrap(function fetchDisciplines$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return (0, _effects.call)(_api.request, 'get', '/disciplines');

                case 3:
                    response = _context.sent;
                    disciplines = response.data.reduce(function (aggr, discipline) {

                        aggr[discipline.id] = discipline;
                        return aggr;
                    }, {});
                    _context.next = 7;
                    return (0, _effects.put)(_disciplines.actionCreators.fetchDisciplinesSucceeded(disciplines));

                case 7:
                    _context.next = 13;
                    break;

                case 9:
                    _context.prev = 9;
                    _context.t0 = _context['catch'](0);
                    _context.next = 13;
                    return (0, _effects.put)(_disciplines.actionCreators.fetchDisciplinesFailed());

                case 13:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[0, 9]]);
}

function fetchDisciplinesRequest() {
    return regeneratorRuntime.wrap(function fetchDisciplinesRequest$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.takeLatest)(_disciplines.actionTypes.FETCH_DISCIPLINES_REQUEST, fetchDisciplines);

                case 2:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

exports.default = [fetchDisciplinesRequest];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/effects/disciplines.js
// module id = 2220
// module chunks = 0